module.exports = __webpack_public_path__ + "img/icon-ai-dark-blue.655e9087.svg";